import { NgModule } from '@angular/core';
import { CobaltSdkService } from './services/cobalt-sdk.service';

@NgModule({
	providers: [CobaltSdkService], // Provide the SDK service
	imports: [], // Add other module dependencies if needed
	declarations: [], // Empty unless you add components
	exports: [], // Empty unless you export components
})
export class CobaltSdkModule {}
